window.addEventListener("load", function(){
    
    
    let dropdowns = document.querySelectorAll("nav .dropdown-toggle");
    let dropdown_ul = document.querySelectorAll("nav .overflow-scroll-ul")[0];


    if( dropdowns ){ 

        for (var i = 0; i < dropdowns.length; i++) {

            dropdowns[i].addEventListener('show.bs.dropdown', function () {

                dropdown_ul.classList.add('dropdown_open');
                
            });
            dropdowns[i].addEventListener('hide.bs.dropdown', function () {

                dropdown_ul.classList.remove('dropdown_open');

            });
            
            
        }

    }


});